<template>
  <div v-if="params.value" class="file-wrapper">
    <a
      :href="params.value.url"
      target="_blank"
      class="link-item__link fake-link"
      @click.prevent="download(params.value.id)"
    >
      <Grid gaf="column" gap="var(--r-space-sm)" justify-content="start" align-items="center">
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.9425 7.25H11.75V3.5C11.75 3.0875 11.4125 2.75 11 2.75H8C7.5875 2.75 7.25 3.0875 7.25 3.5V7.25H6.0575C5.39 7.25 5.0525 8.06 5.525 8.5325L8.9675 11.975C9.26 12.2675 9.7325 12.2675 10.025 11.975L13.4675 8.5325C13.94 8.06 13.61 7.25 12.9425 7.25ZM4.25 14.75C4.25 15.1625 4.5875 15.5 5 15.5H14C14.4125 15.5 14.75 15.1625 14.75 14.75C14.75 14.3375 14.4125 14 14 14H5C4.5875 14 4.25 14.3375 4.25 14.75Z"
            fill="#269AE4"
          />
        </svg>

        {{ params.value.name }}
      </Grid>
    </a>

    <div v-if="params.onUpdate" class="trash-icon">
      <TrashIcon @click.native="params.onUpdate(null, 'file', params.data.id)" />
    </div>
  </div>

  <span v-else>
    <template v-if="params.onUpdate">
      <span v-if="isUploading">Uploading...</span>

      <q-file v-else :value="null" borderless label-slot @input="onNewFileSelected">
        <template #label>
          <div class="text-body-1 text-link-blue q-pl-xs">Choose or drag a file</div>
        </template>
      </q-file>
    </template>
    <template v-else>N/A</template>
  </span>
</template>

<script>
// Components
import TrashIcon from '@/ui/icons/TrashIcon.vue'

export default {
  components: {
    TrashIcon
  },

  data: () => ({
    isUploading: false
  }),

  methods: {
    download(id) {
      this.$store.dispatch('downloadMedia', id, { root: true })
    },

    onNewFileSelected(newFile) {
      this.isUploading = true
      this.params.onUpdate(newFile, 'file', this.params.data.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.file-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.link-item__link {
  margin-bottom: revert;
}

.q-file {
  @include q-field__control {
    height: 50px;
    min-height: 50px !important;

    .q-field__label {
      transform: revert !important;
    }
  }
}

.trash-icon {
  position: absolute;
  right: 0;
  width: 18px;
  height: 100%;
  padding: 3px 4px;
  background: white;
}
</style>
